const frankyAnimationKeys = ["Normal", "Surprised", "Happy", "Stressed"] as const;
export type FrankyAnimation = typeof frankyAnimationKeys[number];

export const getRandomFranky = () => frankyAnimationKeys[Math.floor(Math.random() * frankyAnimationKeys.length)];
